// Translations for Grupo Arista Landing Page

export const translations = {
  es: {
    // Navigation
    nav: {
      home: "Inicio",
      about: "Nosotros",
      solutions: "Soluciones",
      gallery: "Galería",
      contact: "Contacto",
      quote: "Cotizar"
    },
    
    // Hero Section
    hero: {
      location: "Playa del Carmen, Quintana Roo",
      title1: "Fabricación, Construcción",
      title2: "y Mantenimiento",
      subtitle: "Somos fabricantes directos con 7 años de trayectoria. Sin intermediarios. Con capacidad de volumen y soluciones a medida para desarrolladores, constructoras y arquitectos.",
      cta1: "Solicita tu cotización",
      cta2: "Nuestras Soluciones"
    },
    
    // Stats Section
    stats: {
      title: "NO SOMOS INTERMEDIARIOS",
      subtitle: "Capacidad probada en la Riviera Maya",
      years: "Años de experiencia",
      kitchens: "Cocinas integrales",
      closets: "Closets y vestidores",
      railings: "Canceles y barandales"
    },
    
    // About Section
    about: {
      subtitle: "Quiénes Somos",
      title: "Manufactura Arquitectónica Integral",
      p1: "es una fábrica especializada en manufactura arquitectónica integral con 7 años de experiencia ejecutando proyectos residenciales y comerciales de alta gama en la Riviera Maya.",
      p2: "A través de producción propia y un riguroso control de procesos, ofrecemos capacidad de volumen y soluciones diseñadas específicamente para las necesidades de cada proyecto.",
      highlight: "No somos intermediarios",
      p3: "— fabricamos, construimos y mantenemos con equipo propio.",
      cta: "Ver Soluciones"
    },
    
    // Solutions Section
    solutions: {
      subtitle: "Nuestras Soluciones",
      title: "Tres divisiones especializadas",
      description: "Trabajamos de forma integrada para cubrir cada etapa de tu proyecto.",
      aristaq: {
        name: "AristaQ",
        type: "FÁBRICA",
        description: "Fabricación arquitectónica de alta calidad con producción propia y control total del proceso.",
        services: [
          "Cocinas integrales (económica, media, premium y lujo)",
          "Closets y vestidores",
          "Puertas interiores y exteriores",
          "Muebles de baño",
          "Carpintería fija comercial",
          "Cancelería de aluminio",
          "Barandales y canceles de baño",
          "Muebles especiales a medida"
        ]
      },
      aristac: {
        name: "AristaC",
        type: "CONSTRUCCIÓN",
        description: "Obra civil completa desde cero o remodelación integral. Dirección técnica y entrega llave en mano.",
        services: [
          "Obra civil completa",
          "Construcción de casas desde cero",
          "Remodelaciones integrales",
          "Instalaciones eléctricas e hidráulicas",
          "HVAC, plafones, pintura, pisos",
          "Impermeabilización",
          "Supervisión para terceros",
          "Entrega llave en mano"
        ]
      },
      aristam: {
        name: "AristaM",
        type: "MANTENIMIENTO",
        description: "Mantenimiento preventivo y correctivo para propiedades residenciales, comerciales y de renta.",
        services: [
          "Mantenimiento residencial y comercial",
          "Contratos anuales y atención express",
          "Reparaciones estructurales",
          "Mantenimiento preventivo",
          "Administración técnica de edificios",
          "Servicio a inmobiliarias",
          "Servicio a Airbnb y renta larga"
        ]
      }
    },
    
    // Why Choose Us
    whyChoose: {
      subtitle: "Por Qué Elegirnos",
      title: "Tu aliado estratégico en cada etapa",
      features: [
        {
          title: "Fabricación propia",
          description: "No dependemos de terceros. Controlamos calidad, tiempos y costos desde nuestra planta."
        },
        {
          title: "Experiencia local",
          description: "7 años operando en la Riviera Maya. Conocemos la zona, los materiales y las exigencias del mercado."
        },
        {
          title: "Capacidad de volumen",
          description: "Listos para proyectos residenciales y comerciales de gran escala sin perder el detalle."
        },
        {
          title: "Solución integral",
          description: "Desde la fábrica hasta el mantenimiento post entrega. Un solo proveedor para todo el ciclo del proyecto."
        }
      ]
    },
    
    // Gallery
    gallery: {
      subtitle: "Portafolio",
      title: "Nuestros Proyectos",
      images: [
        "Cocina Integral",
        "Closet Premium",
        "Cancelería Exterior",
        "Pérgola",
        "Mampara Fija"
      ]
    },
    
    // Testimonials
    testimonials: {
      subtitle: "Testimonios",
      title: "Lo que dicen nuestros clientes",
      items: [
        {
          content: "Grupo Arista ha sido nuestro aliado en más de 50 unidades residenciales. La calidad y puntualidad son impecables.",
          name: "Carlos Mendoza",
          role: "Director General",
          company: "Desarrollos Costa Maya"
        },
        {
          content: "El nivel de detalle en sus cocinas integrales supera las expectativas. Recomiendo ampliamente sus servicios.",
          name: "María González",
          role: "Arquitecta Principal",
          company: "Arquitectura MG"
        },
        {
          content: "La capacidad de volumen sin perder calidad es lo que diferencia a Grupo Arista. Excelente servicio.",
          name: "Roberto Sánchez",
          role: "Gerente de Proyectos",
          company: "Constructora Riviera"
        }
      ]
    },
    
    // Map Section
    map: {
      subtitle: "Ubicación",
      title: "Encuéntranos en la Riviera Maya",
      address: "Dirección",
      addressValue: "Playa del Carmen, Quintana Roo, México",
      phone: "Teléfono",
      schedule: "Horario",
      scheduleValue: "Lunes a Viernes: 9:00 AM - 6:00 PM"
    },
    
    // Contact Section
    contact: {
      subtitle: "Contacto",
      title: "¿Tienes un proyecto en mente?",
      description: "Cuéntanos qué necesitas. Te asesoramos sin compromiso y te presentamos una propuesta a medida para tu desarrollo.",
      form: {
        name: "Nombre completo",
        email: "Correo electrónico",
        phone: "Teléfono",
        projectType: "Tipo de proyecto",
        projectTypes: {
          residential: "Residencial",
          commercial: "Comercial",
          renovation: "Remodelación",
          maintenance: "Mantenimiento"
        },
        message: "Cuéntanos sobre tu proyecto...",
        submit: "Enviar Mensaje",
        sending: "Enviando..."
      },
      direct: "Contacto Directo",
      whatsapp: "WhatsApp",
      emailLabel: "Email",
      follow: "Síguenos",
      success: "¡Mensaje enviado! Te contactaremos pronto.",
      error: "Error al enviar. Intenta de nuevo."
    },
    
    // Footer
    footer: {
      tagline: "Tu aliado estratégico",
      copyright: "© 2026 Grupo Arista — Playa del Carmen, Quintana Roo"
    },
    
    // Chat Widget
    chat: {
      title: "Chat en Vivo",
      subtitle: "¿Cómo podemos ayudarte?",
      welcome: "¡Hola! Bienvenido a Grupo Arista. Escríbenos tu consulta y te responderemos a la brevedad.",
      namePlaceholder: "Nombre",
      emailPlaceholder: "Email",
      messagePlaceholder: "Escribe tu mensaje...",
      error: "Error al enviar mensaje"
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      solutions: "Solutions",
      gallery: "Gallery",
      contact: "Contact",
      quote: "Quote"
    },
    
    // Hero Section
    hero: {
      location: "Playa del Carmen, Quintana Roo",
      title1: "Manufacturing, Construction",
      title2: "and Maintenance",
      subtitle: "We are direct manufacturers with 7 years of experience. No intermediaries. With volume capacity and custom solutions for developers, construction companies, and architects.",
      cta1: "Request a Quote",
      cta2: "Our Solutions"
    },
    
    // Stats Section
    stats: {
      title: "WE ARE NOT INTERMEDIARIES",
      subtitle: "Proven capacity in the Riviera Maya",
      years: "Years of experience",
      kitchens: "Custom kitchens",
      closets: "Closets and dressing rooms",
      railings: "Railings and partitions"
    },
    
    // About Section
    about: {
      subtitle: "About Us",
      title: "Comprehensive Architectural Manufacturing",
      p1: "is a factory specialized in comprehensive architectural manufacturing with 7 years of experience executing high-end residential and commercial projects in the Riviera Maya.",
      p2: "Through our own production and rigorous process control, we offer volume capacity and solutions specifically designed for each project's needs.",
      highlight: "We are not intermediaries",
      p3: "— we manufacture, build, and maintain with our own team.",
      cta: "View Solutions"
    },
    
    // Solutions Section
    solutions: {
      subtitle: "Our Solutions",
      title: "Three specialized divisions",
      description: "We work in an integrated way to cover every stage of your project.",
      aristaq: {
        name: "AristaQ",
        type: "FACTORY",
        description: "High-quality architectural manufacturing with in-house production and total process control.",
        services: [
          "Custom kitchens (economy, mid-range, premium, and luxury)",
          "Closets and dressing rooms",
          "Interior and exterior doors",
          "Bathroom furniture",
          "Commercial fixed carpentry",
          "Aluminum window frames",
          "Railings and bathroom partitions",
          "Custom special furniture"
        ]
      },
      aristac: {
        name: "AristaC",
        type: "CONSTRUCTION",
        description: "Complete civil works from scratch or full renovation. Technical direction and turnkey delivery.",
        services: [
          "Complete civil works",
          "House construction from scratch",
          "Full renovations",
          "Electrical and plumbing installations",
          "HVAC, ceilings, painting, floors",
          "Waterproofing",
          "Third-party supervision",
          "Turnkey delivery"
        ]
      },
      aristam: {
        name: "AristaM",
        type: "MAINTENANCE",
        description: "Preventive and corrective maintenance for residential, commercial, and rental properties.",
        services: [
          "Residential and commercial maintenance",
          "Annual contracts and express service",
          "Structural repairs",
          "Preventive maintenance",
          "Building technical management",
          "Real estate services",
          "Airbnb and long-term rental services"
        ]
      }
    },
    
    // Why Choose Us
    whyChoose: {
      subtitle: "Why Choose Us",
      title: "Your strategic partner at every stage",
      features: [
        {
          title: "In-house manufacturing",
          description: "We don't depend on third parties. We control quality, timelines, and costs from our plant."
        },
        {
          title: "Local experience",
          description: "7 years operating in the Riviera Maya. We know the area, the materials, and market demands."
        },
        {
          title: "Volume capacity",
          description: "Ready for large-scale residential and commercial projects without losing attention to detail."
        },
        {
          title: "Comprehensive solution",
          description: "From factory to post-delivery maintenance. One supplier for the entire project cycle."
        }
      ]
    },
    
    // Gallery
    gallery: {
      subtitle: "Portfolio",
      title: "Our Projects",
      images: [
        "Custom Kitchen",
        "Premium Closet",
        "Exterior Window Frames",
        "Pergola",
        "Fixed Partition"
      ]
    },
    
    // Testimonials
    testimonials: {
      subtitle: "Testimonials",
      title: "What our clients say",
      items: [
        {
          content: "Grupo Arista has been our partner in over 50 residential units. The quality and punctuality are impeccable.",
          name: "Carlos Mendoza",
          role: "General Director",
          company: "Desarrollos Costa Maya"
        },
        {
          content: "The level of detail in their custom kitchens exceeds expectations. I highly recommend their services.",
          name: "María González",
          role: "Principal Architect",
          company: "Arquitectura MG"
        },
        {
          content: "The volume capacity without losing quality is what sets Grupo Arista apart. Excellent service.",
          name: "Roberto Sánchez",
          role: "Project Manager",
          company: "Constructora Riviera"
        }
      ]
    },
    
    // Map Section
    map: {
      subtitle: "Location",
      title: "Find us in the Riviera Maya",
      address: "Address",
      addressValue: "Playa del Carmen, Quintana Roo, Mexico",
      phone: "Phone",
      schedule: "Hours",
      scheduleValue: "Monday to Friday: 9:00 AM - 6:00 PM"
    },
    
    // Contact Section
    contact: {
      subtitle: "Contact",
      title: "Have a project in mind?",
      description: "Tell us what you need. We'll advise you with no obligation and present a custom proposal for your development.",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone",
        projectType: "Project type",
        projectTypes: {
          residential: "Residential",
          commercial: "Commercial",
          renovation: "Renovation",
          maintenance: "Maintenance"
        },
        message: "Tell us about your project...",
        submit: "Send Message",
        sending: "Sending..."
      },
      direct: "Direct Contact",
      whatsapp: "WhatsApp",
      emailLabel: "Email",
      follow: "Follow Us",
      success: "Message sent! We'll contact you soon.",
      error: "Error sending. Please try again."
    },
    
    // Footer
    footer: {
      tagline: "Your strategic partner",
      copyright: "© 2026 Grupo Arista — Playa del Carmen, Quintana Roo"
    },
    
    // Chat Widget
    chat: {
      title: "Live Chat",
      subtitle: "How can we help you?",
      welcome: "Hello! Welcome to Grupo Arista. Send us your inquiry and we'll respond shortly.",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      messagePlaceholder: "Type your message...",
      error: "Error sending message"
    }
  }
};

export default translations;
